import { UserProfileStrainReview } from "@/custom-types/Reviews";

import ReviewCard from "../ReviewCard";

type Props = {
  review: UserProfileStrainReview;
};

const StrainReviewCard = ({
  review: { created, isPrivate, reportedFeelings, strain, text },
}: Props) => {
  const { name, slug } = strain || {};
  return (
    <ReviewCard
      text={text}
      title={name || ""}
      itemUrl={`/strains/${slug}`}
      createdDate={created}
      isPrivate={isPrivate}
      reportedFeelings={reportedFeelings}
    />
  );
};

export default StrainReviewCard;
